<div class="landing-wrapper">
  <div class="hero card-glass mb-4">
    <div class="hero-grid">
      <div class="hero-copy">
        <p class="eyebrow">Spay · Le wallet qui simplifie vos paiements</p>
        <h1>Payez, transférez et retirez en toute confiance.</h1>
        <p class="lead">Un compte unique pour vos dépenses quotidiennes et votre activité, avec validation client et suivi en temps réel.</p>
        <div class="cta-row">
          <a routerLink="/connection" class="btn btn-primary btn-pill">Ouvrir mon espace</a>
          <a routerLink="/signup" class="btn btn-outline-light btn-pill">Créer un compte gratuit</a>
          <button type="button" class="btn btn-install btn-pill" [class.btn-install-muted]="!shouldInstallPwa()"
            [disabled]="isPwaInstalled()" (click)="installPwa()">
            <i [class]="getInstallButtonIcon() + ' me-2'"></i>
            {{ getInstallButtonLabel() }}
          </button>
        </div>
        <div *ngIf="installHelpVisible" class="install-help">
          <strong>Installation disponible via le navigateur.</strong>
          <span>Sur Chrome ou Edge, ouvrez le menu du navigateur puis choisissez <em>Installer l'application</em>, ou utilisez l'icône d'installation dans la barre d'adresse.</span>
        </div>
        <div class="hero-metrics">
          <div class="metric">
            <strong>Instantané</strong>
            <span>Validation en quelques secondes</span>
          </div>
          <div class="metric">
            <strong>Sécurisé</strong>
            <span>Code, identité et contrôles d'accès</span>
          </div>
          <div class="metric">
            <strong>Traçable</strong>
            <span>Historique clair de chaque opération</span>
          </div>
        </div>
      </div>
      <div class="hero-badge">
        <div class="badge-inner">
          <span class="pill pill-strong">Transactions instantanées</span>
          <span class="pill">Validation client</span>
          <span class="pill">Traçabilité complète</span>
        </div>
      </div>
    </div>
  </div>

  <div class="journey-panel glass-panel">
    <div class="journey-header">
      <div>
        <p class="eyebrow">Choisissez votre profil</p>
        <h3>Un parcours clair en 3 étapes</h3>
      </div>
      <div class="journey-tabs" role="tablist" aria-label="Type de profil">
        <button
          type="button"
          class="journey-tab"
          [class.active]="activeJourney === 'particulier'"
          (click)="setJourney('particulier')">
          <i class="bi bi-person"></i>
          <span>Particulier</span>
        </button>
        <button
          type="button"
          class="journey-tab"
          [class.active]="activeJourney === 'business'"
          (click)="setJourney('business')">
          <i class="bi bi-briefcase"></i>
          <span>Business</span>
        </button>
      </div>
    </div>

    <div class="journey-summary">
      <div>
        <p class="eyebrow mb-1">{{activeJourneyContent.eyebrow}}</p>
        <h4>{{activeJourneyContent.title}}</h4>
      </div>
      <span class="chip" [class.chip-pro]="activeJourney === 'business'">{{activeJourneyContent.badge}}</span>
    </div>

    <div class="steps-grid">
      <div class="step-card" *ngFor="let step of activeJourneyContent.steps; index as i">
        <div class="step-top">
          <span class="step-index">0{{i + 1}}</span>
          <div class="step-icon">
            <i [class]="step.icon"></i>
          </div>
        </div>
        <h5>{{step.title}}</h5>
        <p>{{step.text}}</p>
      </div>
    </div>
  </div>
</div>
